import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';
import MarketplaceCategoryResource from './MarketplaceCategoryResource';

export default class MarketplaceCategoriesResource extends BaseResource {
  constructor() {
    super({ url: '/api/categories' });
  }

  list({ size = 15, includes = '', search = '', offset = 0 } = {}) {
    const params = { size, includes, offset, search };
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  create(data) {
    return super
      .post(data)
      .then((response) => response)
      .catch((error) => error.response);
  }

  category(id) {
    return new MarketplaceCategoryResource(`${this.url}/${id}`);
  }
}
